import * as React from 'react'

function IconClover({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={104}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g
            filter="url(#prefix__filter1_clover)"
            strokeMiterlimit={10}
            strokeLinecap="round"
          >
            <path
              d="M98.075 43.244a21.952 21.952 0 000 17.507c6.577 15.14 6.817 28.913-.797 36.527-7.61 7.614-21.382 7.37-36.522.797a21.95 21.95 0 00-17.506 0c-15.14 6.577-28.916 6.817-36.53-.797C-.89 89.664-.646 75.89 5.927 60.75a21.952 21.952 0 000-17.507C-.65 28.104-.893 14.331 6.72 6.717c7.618-7.61 21.39-7.367 36.53-.79a21.95 21.95 0 0017.506 0c15.14-6.577 28.912-6.82 36.522.794 7.614 7.614 7.374 21.386.797 36.523z"
              fill="#fff"
              stroke={color}
              strokeWidth={2}
            />
            <path
              d="M81.171 96.108c-5.15 0-11.32-1.509-17.842-4.362a28.925 28.925 0 00-11.67-2.445c-4.04 0-7.965.822-11.672 2.442-6.52 2.852-12.692 4.361-17.846 4.361-4.702 0-8.296-1.219-10.68-3.62-5.008-5.048-4.727-16.055.737-28.73a29.805 29.805 0 000-23.512C6.734 27.568 6.45 16.56 11.46 11.512c2.384-2.398 5.975-3.616 10.676-3.616 5.154 0 11.325 1.509 17.85 4.361A28.924 28.924 0 0051.658 14.7c4.039 0 7.964-.822 11.671-2.445C69.85 9.4 76.021 7.892 81.175 7.892c4.699 0 8.289 1.215 10.673 3.616 5.011 5.049 4.73 16.056-.733 28.73a29.804 29.804 0 000 23.513c5.464 12.674 5.745 23.681.733 28.73-2.384 2.408-5.978 3.627-10.677 3.627z"
              fill={color}
              stroke="#fff"
            />
          </g>
          <defs>
            <filter
              id="prefix__filter1_clover"
              x={0}
              y={0}
              width={104}
              height={104}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M98.075 43.244a21.952 21.952 0 000 17.507c6.577 15.14 6.817 28.913-.797 36.527-7.61 7.614-21.382 7.37-36.522.797a21.95 21.95 0 00-17.506 0c-15.14 6.577-28.916 6.817-36.53-.797C-.89 89.664-.646 75.89 5.927 60.75a21.952 21.952 0 000-17.507C-.65 28.104-.893 14.331 6.72 6.717c7.618-7.61 21.39-7.367 36.53-.79a21.95 21.95 0 0017.506 0c15.14-6.577 28.912-6.82 36.522.794 7.614 7.614 7.374 21.386.797 36.523z"
            fill="#fff"
            stroke={color}
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M81.171 96.108c-5.15 0-11.32-1.509-17.842-4.362a28.925 28.925 0 00-11.67-2.445c-4.04 0-7.965.822-11.672 2.442-6.52 2.852-12.692 4.361-17.846 4.361-4.702 0-8.296-1.219-10.68-3.62-5.008-5.048-4.727-16.055.737-28.73a29.805 29.805 0 000-23.512C6.734 27.568 6.45 16.56 11.46 11.512c2.384-2.398 5.975-3.616 10.676-3.616 5.154 0 11.325 1.509 17.85 4.361A28.924 28.924 0 0051.658 14.7c4.039 0 7.964-.822 11.671-2.445C69.85 9.4 76.021 7.892 81.175 7.892c4.699 0 8.289 1.215 10.673 3.616 5.011 5.049 4.73 16.056-.733 28.73a29.804 29.804 0 000 23.513c5.464 12.674 5.745 23.681.733 28.73-2.384 2.408-5.978 3.627-10.677 3.627z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconClover
